import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, RangeSelect } from "@/components/admin/shared";
import { CHART_COLORS } from "@/lib/constants";
import {
  PieChart, Pie, Cell, ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Legend, LineChart, Line,
} from "recharts";

export default function Analytics() {
  const [range, setRange] = useState("30days");
  const [purpose, setPurpose] = useState([]);
  const [source, setSource] = useState([]);
  const [demo, setDemo] = useState(null);
  const [series, setSeries] = useState([]);

  const load = async () => {
    const [p, s, d, ts] = await Promise.all([
      api.get(`/analytics/purpose?range=${range}`), api.get(`/analytics/source?range=${range}`),
      api.get(`/analytics/demographics?range=${range}`), api.get(`/analytics/timeseries?days=14`),
    ]);
    setPurpose(p.data); setSource(s.data); setDemo(d.data); setSeries(ts.data);
  };
  useEffect(() => { load(); }, [range]);

  return (
    <div>
      <PageHeader title="Visitor Analytics" subtitle="Deep insights across your visitor base"><RangeSelect value={range} onChange={setRange} /></PageHeader>

      <Panel title="Daily Visitors — New vs Returning (14 days)" className="mb-5">
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={series}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis dataKey="date" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} allowDecimals={false} /><Tooltip /><Legend wrapperStyle={{ fontSize: 11 }} />
            <Line type="monotone" dataKey="new" stroke="#D95D1E" strokeWidth={2.5} dot={false} />
            <Line type="monotone" dataKey="returning" stroke="#0f2042" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </Panel>

      <div className="grid lg:grid-cols-2 gap-5 mb-5">
        <Panel title="Purpose of Visit">
          <ResponsiveContainer width="100%" height={280}>
            <PieChart><Pie data={purpose} dataKey="value" nameKey="name" innerRadius={60} outerRadius={100} paddingAngle={2}>{purpose.map((e, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}</Pie><Tooltip /><Legend wrapperStyle={{ fontSize: 11 }} /></PieChart>
          </ResponsiveContainer>
        </Panel>
        <Panel title="Interest Categories">
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={demo?.interests?.slice(0, 8) || []} layout="vertical"><CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} /><YAxis type="category" dataKey="name" tick={{ fontSize: 11 }} width={90} /><Tooltip /><Bar dataKey="value" fill="#E8752A" radius={[0, 4, 4, 0]} /></BarChart>
          </ResponsiveContainer>
        </Panel>
      </div>

      <div className="grid lg:grid-cols-3 gap-5">
        <Panel title="Gender Split">
          <ResponsiveContainer width="100%" height={240}>
            <PieChart><Pie data={demo?.gender || []} dataKey="value" nameKey="name" outerRadius={90}>{(demo?.gender || []).map((e, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}</Pie><Tooltip /><Legend wrapperStyle={{ fontSize: 11 }} /></PieChart>
          </ResponsiveContainer>
        </Panel>
        <Panel title="Age Groups">
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={demo?.age || []}><CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis dataKey="name" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} allowDecimals={false} /><Tooltip /><Bar dataKey="value" fill="#0284C7" radius={[4, 4, 0, 0]} /></BarChart>
          </ResponsiveContainer>
        </Panel>
        <Panel title="Visitor Source">
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={source}><CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis dataKey="source" tick={{ fontSize: 9 }} interval={0} angle={-20} textAnchor="end" height={50} /><YAxis tick={{ fontSize: 11 }} allowDecimals={false} /><Tooltip /><Bar dataKey="visitors" fill="#0f2042" radius={[4, 4, 0, 0]} /></BarChart>
          </ResponsiveContainer>
        </Panel>
      </div>
    </div>
  );
}
